import { Props } from 'docz';
import { Playground } from '@playground';
import { Link } from "../../../../../packages/core/src/components/links/links";
import * as React from 'react';
export default {
  Props,
  Playground,
  Link,
  React
};